import { Checkbox, FormControlLabel } from '@mui/material'
import { Controller, UseFormReturn } from 'react-hook-form'

interface CheckBox {
  label: string
  style?: {
    height: number
    width: {
      xs: string | number
    }
    backgroundColor: string
    borderBottom: string
  }
  styleTypography?: {
    fontWeight: number
    color: string
  }
  form: UseFormReturn<any, any>
}

const InputCheckBox = ({ label, style, form, styleTypography }: CheckBox) => {
  const {
    control,
  } = form

  return (
    <Controller
      name="controller"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          sx={{
            textTransform: 'capitalize',
            marginLeft: '0px',
            marginRight: '0px',
            [`& .MuiTypography-root`]: {
              marginLeft: '15px',
              ...styleTypography,
            },
            [`& .MuiSvgIcon-root`]: {
              fontSize: '1rem',
            },
            ...style,
          }}
          control={<Checkbox {...field} />}
          label={label}
        />
      )}
    />

  )
}

export default InputCheckBox
